module.exports = __webpack_public_path__ + "img/lancamento-lemonde-desktop.1ef74e8f.webp";